import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ['url']

  visit() {
    Turbo.visit(`/${ this.urlTarget.value }`)
  }

  reset() {
    this.urlTarget.value = ''
  }
}
